import React from "react";
import classNames from "classnames/bind";
import styles from "./NavigationDropdown.module.scss";
import { Link } from "react-router-dom";

const cx = classNames.bind(styles);

const NavigationDropdown = ({ dropdown }) => {

  
  return (
    <div className={cx("dropdown")}>
      <div className={cx("dropdown__title")}>{dropdown.title}</div>
      <ul className={cx("dropdown__list")}>
        {Object.entries(dropdown)
          .filter(([catKey]) => catKey !== "title")
          .map(([catKey, catLabel]) => (
            <li key={catKey} className={cx("dropdown__item")}>
              <Link to={`/products/category/${catKey.split("_").join("-")}`} className={cx("dropdown__link")}>
                {catLabel}
              </Link>
            </li>
          ))
        }
       
      </ul>
    </div>
  );
};

export default NavigationDropdown;
